import React from "react";

const integrations = [
  {
    name: "Calendly",
    icon: "📅",
    componentKey: "48", // Maps to CalendlyBooking
  },
  {
    name: "Zoho",
    icon: "🧩",
    componentKey: "49", // Maps to Zoho
  },
];

const IntegrationsOverview = () => {
  const handleIntegrationClick = (key) => {
    localStorage.setItem("activePage", key);
    window.location.href = "/";
  };

  return (
    <div style={{ padding: "2rem" }}>
      <h2 style={{ marginBottom: "1rem" }}>🔌 Available Integrations</h2>
      <div
        style={{
          display: "flex",
          gap: "2rem",
          flexWrap: "wrap",
        }}
      >
        {integrations.map((integration) => (
          <div
            key={integration.name}
            onClick={() => handleIntegrationClick(integration.componentKey)}
            style={{
              cursor: "pointer",
              width: "200px",
              padding: "1.5rem",
              backgroundColor: "#f9f9f9",
              border: "1px solid #ddd",
              borderRadius: "12px",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              textAlign: "center",
              transition: "0.3s",
            }}
          >
            <div style={{ fontSize: "2.5rem" }}>{integration.icon}</div>
            <h3 style={{ marginTop: "1rem", fontWeight: "600" }}>
              {integration.name}
            </h3>
          </div>
        ))}
      </div>
    </div>
  );
};

export default IntegrationsOverview;
